import React from 'react';
import PropTypes from 'prop-types';
import InputBlocks from './InputBlocks';
import './GeneralSettings.scss';
import useForm from '../../hooks/useForm';

export default function GeneralSettings({
  onChange,
  value,
  meta,
  errors = {},
}) {
  // This interceptor runs everytime the form is updated, we want to sometimes
  // update other form values based on the current key being changed
  const interceptor = (key, val, newForm) => {
    let updatedForm = newForm;
    if (key === 'activeBots') {
      updatedForm = { ...newForm };
      const indexOfDefaultBot = val.indexOf(newForm.defaultBot);
      const indexOfFallbackBot = val.indexOf(newForm.fallbackBot);
      if (indexOfDefaultBot === -1) updatedForm.defaultBot = '';
      if (indexOfFallbackBot === -1) updatedForm.fallbackBot = '';
    }

    if (key === 'businessName' && meta.isNew) {
      updatedForm = { ...newForm };
      updatedForm.businessViaName = `${newForm.businessName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '')}channel`;
    }

    return updatedForm;
  };

  const [, getInputProps] = useForm(value, { meta, onChange, interceptor });
  return (
    <div className="general-settings">
      {InputBlocks.blocks.map(block => (
        <div className={`general-settings-block ${block.className}`}>
          <div className="general-settings-title">{block.title}</div>
          <div className="general-settings-inputs">
            {block.inputs.map((input, i) => {
              const Input = input.component;
              const inputProps = getInputProps(input, errors);
              if (inputProps.invisible) return null;
              return (
                <Input
                  {...inputProps}
                  businessId={meta.id}
                  key={`${inputProps.key}-${i}`}
                  className={`${input.className || ''} general-settings-input`}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

GeneralSettings.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.object,
  meta: PropTypes.object,
  errors: PropTypes.object,
};

GeneralSettings.defaultProps = {
  value: InputBlocks.defaults,
  meta: {},
  onChange: () => {},
  errors: {},
};
